module.exports = __webpack_public_path__ + "static/media/IMG_1504.17f86480.jpg";